import React from "react";
// import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";
import "./utils/i18n";
import { CartContext } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { ProfileContext } from "./context/ProfileContext";
import { AddressContext } from "./context/AddressContext";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    {/* <Provider>/ */}
    <CartContext>
      <AuthProvider>
        <SearchProvider>
        <AddressContext>
          <ProfileContext>
            <App />
          </ProfileContext>
          </AddressContext>
        </SearchProvider>
      </AuthProvider>
    </CartContext>

    {/* </Provider> */}
  </Router>
);
